/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Tc, $, w, d, SCS) {
	'use strict';

	/**
	 * PexFavoriteList
	 *
	 * @author ewessolek, Rami A, David T
	 * @namespace Tc.Module
	 * @class PexFavoriteList
	 * @extends Tc.Module
	 */
	Tc.Module.PexFavoriteList = Tc.Module.extend({

		on: function (callback) {
			var mod = this,
				$ctx = mod.$ctx,
				$listContainer = $ctx.find('.scs-favorites-list-container'),
				$showfavoriteList = $ctx.find('.show-favorite-list'),
				$showfavoriteListArrow = $showfavoriteList.find('span'),
				mobileSearch;

			// Module vars
			mod.listData = null;
			mod.normalTemplate = null;
			mod.editTemplate = null;
			mod.baseurl = null;
			mod.list = null;
			mod.isMobile = SCS.utils.isMobilePage();

			// open/close list
			$showfavoriteList.click(function () {

				// Check if search bar is visible
				if (mod.isMobile) {
					mobileSearch = $ctx.parent().prev();
					if (mobileSearch.hasClass('scs-sitesearch-active-icon')) {
						mobileSearch.removeClass('scs-sitesearch-active-icon');
						$('#scs-pageheader-search-form').slideUp('fast');
					}
				} else {
					$showfavoriteListArrow.toggleClass('arrow-up').toggleClass('arrow-down');
				}

				$ctx.toggleClass('open');

				if (!mod.listData) {
					mod.readJson();

					// Sizing of the list-container
					if (!mod.isMobile) {
						var $win = $(w),
							topPos = $listContainer.offset().top,
							bottomSpacing = 100,
							$listContent = $listContainer.find('.scs-favorites-list-content'),
							otherHeight = $listContent.height() - $listContent.height();

						$win.resize(function () {
							$listContent.css('max-height', ($win.height() - topPos - bottomSpacing - otherHeight) + 'px');
						});
					}
				}
			});

			$ctx.click(function (e) {
				e.stopPropagation();
			});

			$(d).click(function () {
				if ($listContainer.is(':visible')) {
					if (!mod.isMobile) {
						$showfavoriteListArrow.removeClass('arrow-up').addClass('arrow-down');
					}

					$ctx.removeClass('open');
				}
			});

			// toggle normal/edit modes
			$ctx.find('a.favorite-list-edit-link').click(function () {
				var link = $(this);

				// call function "normalMode" or "editMode" according to button state
				mod[(link.hasClass('active') ? 'normal' : 'edit') + 'Mode']();
				$ctx[(link.hasClass('active') ? 'remove' : 'add') + 'Class']('edit');

				link.toggleClass('active');
			});

			$ctx.on('click', '.link-actions a.edit', function () {
				$(this).closest('.normal').next('.edit').removeClass('is-hidden').css('display', 'table-row').find('input').focus();
				$(this).closest('.normal').addClass('is-hidden');
			});

			// event listeners
			$ctx.on('click', 'div.normal a.edit', function () {
				$(this).closest('li').addClass('edit');
			});
			$ctx.on('click', 'div.normal a.delete', function () {
				mod.deletePage($(this).closest('li').data('id'));
			});
			$ctx.on('click', 'div.edit a.save', function () {
				mod.editPage(
					$(this).closest('li').data('id'),
					$(this).closest('div.edit').find('input').val()
				);
				$(this).closest('li').find('> .edit').addClass('is-hidden');
				$(this).closest('li').find('> .normal').removeClass('is-hidden');
			});
			$ctx.find('.add-current-url').click(function () {
				if (!$(this).hasClass('disabled')) {
					var start = w.location.href.indexOf(w.location.pathname);
					mod.addPage(w.location.href.substr(start, w.location.href.length), $('head > title').html());
				}
			});

			$ctx.find('.add-url').click(function () {
				var favListExternalUrl = mod.$ctx.find('#favlist-external-url'),
					favListExternalUrlValue = $.trim(favListExternalUrl.val()),
					favListExternalUrlTitle = favListExternalUrlValue;
				if (!$(this).hasClass('disabled') && favListExternalUrlValue) {

					//if link from location.origin & pex ([www|partner(-[sirius|orion|vega])].swisscom.ch/{lang}/pex/), save it relative
					var reg = new RegExp('^' + location.origin + '/(de|fr|it|en)/pex/.*')
					if (reg.test(favListExternalUrlValue)) {
						favListExternalUrlValue = favListExternalUrlValue.replace(w.location.origin, '');
					} else if (!/http[s]?:\/\//.test(favListExternalUrlValue.substr(0, 8))) {
						favListExternalUrlValue = 'http://' + favListExternalUrlValue;
						favListExternalUrlTitle = favListExternalUrlValue;
					}

					mod.addPage(favListExternalUrlValue, favListExternalUrlTitle);
					favListExternalUrl.val('');
				}
			});

			$(d).on('click', '.modPexDocumentList a.save', function () {
				var docLink = $(this),
					addDocument = function () {
						if (mod.checkListLength()) {
							mod.addPage(
								docLink.data('link'),
								docLink.data('title')
							);
							docLink.css('visibility', 'hidden');
						} else {
							$ctx.find('.show-favorite-list').trigger('click');
							$(w).scrollTop(0);
						}
					};

				if (!mod.listData) {
					mod.readJson(addDocument);
				} else {
					addDocument();
				}
			});

			// get templates
			mod.normalTemplate = window.doT.template(mod.$ctx.find('script.tmpl-pexfavoritelistview').html());
			mod.editTemplate = window.doT.template(mod.$ctx.find('script.tmpl-pexfavoritelistedit').html());

			// set module-globals
			mod.baseurl = $ctx.data('baseurl');
			mod.list = mod.$ctx.find('.scs-favorites-list-content ul');

			callback();
		},

		readJson: function (callback) {
			var mod = this;
			var favouriteItem, favouriteJsonData;
			$.getJSON(mod.baseurl + 'favoriteslist.get.json', {noCache: (new Date()).getTime()}, function (json) {
				if (json.success) {
					json = json.favoriteItems;
					favouriteJsonData = [];
					// check for internal/external url
					for (var i = 0; json[i]; i += 1) {
						favouriteItem = json[i];

						if (!favouriteItem.href || favouriteItem.href === null || favouriteItem.href === undefined || favouriteItem.href === '') {
							continue;
						}
						favouriteItem.external = !mod.isInternalUrl(favouriteItem.href);
						favouriteJsonData.push(favouriteItem);
					}
					// save json for later use
					mod.listData = favouriteJsonData;
					// draw link list
					mod.normalMode();
					mod.checkListLength();

					if (typeof callback === 'function') {
						callback();
					}
				} else {
					mod.$ctx.addClass('error-json');
				}
			})
				.fail(function () {
					mod.$ctx.addClass('error-json');
				});
		},

		isInternalUrl: function (url) {
			return (url.indexOf('localhost') > -1 || url.indexOf('swisscom.ch/') > -1 || url.indexOf('swisscom.com/') > -1 || url.indexOf('/') === 0) && url.indexOf('.html') > -1;
		},

		normalMode: function () {
			var mod = this;

			mod.list.html(mod.normalTemplate(mod.listData));
		},

		editMode: function () {
			var mod = this;

			mod.list.html(mod.editTemplate(mod.listData));
		},

		addPage: function (href, title) {
			var mod = this,
				data = {
					href: href,
					title: title || '',
					external: !mod.isInternalUrl(href),
					'_charset_': 'UTF-8'
				};

			$.post(mod.baseurl + 'favoriteslist.add.json', data, function (json) {
				if (json.success) {
					data.id = json.favoriteItems[0].id;
					// append new item to the initial json list data (e.g. reused if the user switches to edit mode)
					mod.listData.unshift(data);
					// append new item to the list
					if (mod.$ctx.hasClass('edit')) {
						mod.list.prepend(mod.editTemplate([data]));
					} else {
						mod.list.prepend(mod.normalTemplate([data]));
					}

					mod.checkListLength();
				} else {
					mod.$ctx.addClass('error-json');
				}
			})
				.fail(function () {
					mod.$ctx.addClass('error-json');
				});
		},

		editPage: function (id, title) {
			var mod = this;

			$.post(mod.baseurl + 'favoriteslist.update.json', {id: id, title: title, '_charset_': 'UTF-8'}, function (json) {
				if (json.success) {
					// change item within the initial json list data (because it is reused if the user switches to edit mode)
					for (var i = 0; mod.listData[i]; i += 1) {
						//compare value of type string with value of type int
						if (String(mod.listData[i].id) === String(id)) {
							mod.listData[i].title = title;
							break;
						}
					}
					// remove item from the list
					mod.list.find('li[data-id="' + id + '"] .link-title > span > span').text(title);
					// toggle edit-view of the active line/link
					mod.$ctx.find('li.edit').removeClass('edit');
				} else {
					mod.$ctx.addClass('error-json');
				}
			})
				.fail(function () {
					mod.$ctx.addClass('error-json');
				});
		},

		deletePage: function (id) {
			var mod = this;

			$.post(mod.baseurl + 'favoriteslist.delete.json', {id: id}, function (json) {
				if (json.success) {
					// remove item from the initial json list data (because it is reused if the user switches to edit mode)
					for (var i = 0; mod.listData[i]; i += 1) {
						//compare value of type string with value of type int
						if (String(mod.listData[i].id) === String(id)) {
							mod.listData.splice(i, 1);
							break;
						}
					}
					// remove item from the list
					mod.list.find('li[data-id="' + id + '"]').remove();

					// restore even/odd classes
					mod.list.find('li').removeClass('odd').removeClass('even');
					mod.list.find('li:nth-child(odd)').addClass('even');
					mod.list.find('li:nth-child(even)').addClass('odd');

					mod.checkListLength();
				} else {
					mod.$ctx.addClass('error-json');
				}
			})
				.fail(function () {
					mod.$ctx.addClass('error-json');
				});
		},

		checkListLength: function () {
			var mod = this,
				$ctx = mod.$ctx,
				$favlistExternalUrl = $ctx.find('#favlist-external-url'),
				$addUrlButtons = $ctx.find('.add-current-url, .add-url');

			if (mod.listData.length >= 200) {
				$ctx.addClass('error-length-max');
				$favlistExternalUrl.attr('disabled', 'disabled').addClass('disabled');
				$addUrlButtons.addClass('disabled');
				return false;
			} else if ($ctx.hasClass('error-length-max')) {
				$ctx.removeClass('error-length-max');
				$favlistExternalUrl.removeAttr('disabled').removeClass('disabled');
				$addUrlButtons.removeClass('disabled');
			}
			return true;
		}

	});
}(window.Tc, window.Tc.$, window, document, window.SCS = window.SCS || {}));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.PexFavoriteList.js
// module id = 164
// module chunks = 0